import { useContext } from 'react';
import { DartContext } from 'themes/datavant/DatavantProvider';

type LogoPropsMultipleColors = {
    size?: 'small' | 'medium';
    color?: 'black' | 'cyan' | 'white';
};

type LogoPropsOneColor = {
    size?: 'large';
    color?: never;
};

const PRODUCTION_ASSETS_URL = 'https://assets.datavant.com/';
const STAGING_ASSETS_URL = 'https://assets.datavant-staging.com/';

export const Logo = ({ size = 'medium', color = 'black' }: LogoPropsMultipleColors | LogoPropsOneColor) => {
    const { environment } = useContext(DartContext);

    const getLogoFilename = () => {
        if (size === 'large') {
            return 'datavant-logo-full.svg';
        }
        return `datavant-logo-${color}${size === 'small' ? '-small' : ''}.svg`;
    };

    return (
        <img
            src={`${environment === 'staging' ? STAGING_ASSETS_URL : PRODUCTION_ASSETS_URL}${getLogoFilename()}`}
            alt={'Datavant logo'}
        />
    );
};
